import React, { useEffect } from "react";
import Empresas from "../components/Empresas/Empresas";
import i18n from "../i18n/config";

const EmpresasPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("list.breadcrumb", { ns: "empresas" })}`;
  }, []);

  return <Empresas />;
};

export default EmpresasPage;
